<div class="permissions-container">
  <!-- Header Section -->
  <div class="header-section">
    <button mat-button class="nav-button" (click)="navBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="app-info">
      <div class="app-selector">
        <label>Application</label>
        <ng-container *ngIf="userGroupList.length > 0 && !isUpdating && false">
          <!-- Dropdown (never enabled in current logic, but preserved for future use) -->
          <select class="form-control" [disabled]="true">
            <option>{{getAppDisplayName()}}</option>
          </select>
        </ng-container>
        <ng-container *ngIf="true">
          <!-- Show as label when disabled -->
          <div class="form-control-static app-label"
            style="font-size: 1.1em; padding: 6px 12px; background: #fff; border: 1px solid #ced4da; border-radius: 4px; min-height: 25px; display: flex; align-items: center;">
            {{ getAppDisplayName() }}
          </div>
        </ng-container>
      </div>
      <div class="user-group-selector">
        <label>User Group</label>
        <ng-container *ngIf="userGroupList.length > 0 && !isUpdating && false">
          <!-- Dropdown (never enabled in current logic, but preserved for future use) -->
          <select class="form-control" [ngModel]="userGroup?.id" (ngModelChange)="onUserGroupChange($event)"
            [disabled]="true">
            <option value="" disabled>Select User Group</option>
            <option *ngFor="let ug of userGroupList" [value]="ug.id">
              {{ug.name}}
            </option>
          </select>
        </ng-container>
        <ng-container *ngIf="true">
          <!-- Show as label when disabled -->
          <div class="form-control-static user-group-label"
            style="font-size: 1.1em; padding: 6px 12px; background: #fff; border: 1px solid #ced4da; border-radius: 4px; min-height: 25px; display: flex; align-items: center;">
            {{ getUserGroupName() }}
          </div>
        </ng-container>
      </div>
      <div class="search-input-container" style="margin-top: 20px;">
        <div class="free-search">
          <button mat-button class="search-icon">
            <mat-icon>search</mat-icon>
          </button>

          <div class="search-input">
            <input matInput placeholder="Search..." [(ngModel)]="searchText" (input)="applySearchFilter()"
              autocomplete="off" />
          </div>


        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-success" (click)="onUpdate()" [disabled]="isUpdating || permissionGroups.length === 0">
          {{isUpdating ? 'Updating...' : 'Update'}}
        </button>
        <button class="btn btn-secondary" (click)="onDiscard()" [disabled]="isUpdating">Discard</button>
        <!-- <button class="btn btn-primary" (click)="onReload()" [disabled]="isUpdating">Reload</button> -->
      </div>
    </div>
  </div>



  <!-- No Data Message -->
  <div *ngIf="permissionGroups.length === 0" class="no-data-container" style="text-align: center; padding: 40px;">
    <img src="assets/images/no-data.png" alt="No data" style="max-width: 200px;">
    <h3>No Permissions Data</h3>
    <p>No permissions data is available for this user group and application.</p>

    <button class="btn btn-primary" (click)="onDiscard()">Go Back</button>
  </div>

  <!-- Permissions Table -->
  <div class="permissions-table-container" *ngIf="filteredPermissionGroups.length > 0">
    <!-- Single table with one header -->
    <table class="permissions-table">
      <thead>
        <tr>
          <th>Sl.</th>
          <th>Function</th>
          <th>
            <mat-checkbox [checked]="selectAllStates.view.checked" [indeterminate]="selectAllStates.view.indeterminate"
              (change)="onSelectAll('view', $event.checked)">
              View
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.add.checked" [indeterminate]="selectAllStates.add.indeterminate"
              (change)="onSelectAll('add', $event.checked)">
              Add
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.edit.checked" [indeterminate]="selectAllStates.edit.indeterminate"
              (change)="onSelectAll('edit', $event.checked)">
              Edit
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.delete.checked"
              [indeterminate]="selectAllStates.delete.indeterminate" (change)="onSelectAll('delete', $event.checked)">
              Delete
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.exec.checked" [indeterminate]="selectAllStates.exec.indeterminate"
              (change)="onSelectAll('exec', $event.checked)">
              Execute
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.publish.checked"
              [indeterminate]="selectAllStates.publish.indeterminate" (change)="onSelectAll('publish', $event.checked)">
              Publish
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.export.checked"
              [indeterminate]="selectAllStates.export.indeterminate" (change)="onSelectAll('export', $event.checked)">
              Export
            </mat-checkbox>
          </th>
          <th>
            <mat-checkbox [checked]="selectAllStates.import.checked"
              [indeterminate]="selectAllStates.import.indeterminate" (change)="onSelectAll('import', $event.checked)">
              Import
            </mat-checkbox>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Group sections within single table -->
        <ng-container *ngFor="let group of filteredPermissionGroups; let groupIndex = index">
          <!-- Group header row - only show if we have valid groups -->
          <tr class="group-header-row" *ngIf="hasValidGroups">
            <td colspan="10" class="group-header-cell">
              <h5>{{group.groupName}} ({{group.permissions.length}} items)</h5>
            </td>
          </tr>
          <!-- Permission rows for this group -->
          <tr *ngFor="let permission of group.permissions; let i = index" class="permission-row">
            <td>{{hasValidGroups ? (i + 1) : (getGlobalIndex(groupIndex, i) + 1)}}</td>
            <td class="function-name">
              <span class="function-highlight-box">
                {{permission.function_name}}
                <span [class]="getPermissionLevelClass(permission)" *ngIf="getPermissionLevelLabel(permission)">
                  {{ getPermissionLevelLabel(permission) }}
                </span>
              </span>
            </td>
            <td>
              <mat-checkbox [checked]="permission.view" [disabled]="!permission.is_view_applicable"
                (change)="onPermissionChange(permission, 'view', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.add" [disabled]="!permission.is_add_applicable"
                (change)="onPermissionChange(permission, 'add', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.edit" [disabled]="!permission.is_edit_applicable"
                (change)="onPermissionChange(permission, 'edit', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.delete" [disabled]="!permission.is_delete_applicable"
                (change)="onPermissionChange(permission, 'delete', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.exec" [disabled]="!permission.is_execute_applicable"
                (change)="onPermissionChange(permission, 'exec', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.publish" [disabled]="!permission.is_publish_applicable"
                (change)="onPermissionChange(permission, 'publish', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.export" [disabled]="!permission.is_export_applicable"
                (change)="onPermissionChange(permission, 'export', $event.checked)">
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox [checked]="permission.import" [disabled]="!permission.is_import_applicable"
                (change)="onPermissionChange(permission, 'import', $event.checked)">
              </mat-checkbox>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

</div>